module.exports = __webpack_public_path__ + "static/media/Gatwick-Bold.43e1b67c.otf";